if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productForm = this.productSection.querySelector('product-form');
      this.addToCartBtn = this.productForm ? this.productForm.querySelector('[name="add"]') : null;

      if ('IntersectionObserver' in window && this.addToCartBtn) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      if (this.btnObserver) {
        this.btnObserver.disconnect();
      }
    }

    bindEvents() {
      this.btnObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.addToCartBtn) {
            const isBtnVisible = entry.isIntersecting || entry.intersectionRatio > 0;

            // Mostrar sticky panel solo cuando el botón NO es visible
            this.classList.toggle('sticky-atc-panel--show', !isBtnVisible);
          }
        });
      }, {
        threshold: [0, 0.1, 0.5, 1], // Múltiples thresholds para mejor detección
         rootMargin: `-130px 0px 0px 0px`
      });

      this.btnObserver.observe(this.addToCartBtn);
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}